import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import editIcon from '../../../assets/img/icons/edit-pen.svg';
import TableCustomCheckboxDropdown from '../../../components/CustomCheckboxDropdown/TableCustomCheckboxDropdown';
import ComponentCircleLoader from '../../../components/Loaders/ComponentCircleLoader';
import NoDataComponent from '../../../components/NoDataComponent/NoDataComponent';
import TaskActionTooltip from '../../../components/Tooltip/TaskActionTooltip';
import { TableItem } from '../../../styledComponents/ProjectsNew';
import {
  CommonImage,
  Container,
  TableText,
} from '../../../styledComponents/common';
import {
  EditButton,
  ListBody,
  ListContainer,
  ListItem,
  MasterTaskTable,
  SubTaskItem,
  SubTaskList,
} from '../../../styledComponents/tasks';
import { RoundIcon } from '../tasksStyles';

const MasterSubTasksList = ({
  masterSubTasksList,
  editMasterSubTask,
  isLoading = false,
  publicZoneList,
}) => {
  const { t } = useTranslation();
  const [openedOfficeDropdown, setOpenedOfficeDropdown] = useState(null);
  const [openedMasterTaskDropdown, setOpenedMasterTaskDropdown] =
    useState(null);

  const handleOfficeDropdownClick = id => {
    if (openedOfficeDropdown === id) {
      setOpenedOfficeDropdown(null);
    } else {
      setOpenedOfficeDropdown(id);
    }
  };

  const handleMasterTaskDropdownClick = id => {
    if (openedMasterTaskDropdown === id) {
      setOpenedMasterTaskDropdown(null);
    } else {
      setOpenedMasterTaskDropdown(id);
    }
  };

  const handleEdit = task => {
    const updatedTask = { ...task, name: task.name };
    editMasterSubTask({ task_id: task.id, ...updatedTask });
  };

  return (
    <Container style={{ paddingBottom: '20px' }}>
      {isLoading ? (
        <ComponentCircleLoader />
      ) : masterSubTasksList && masterSubTasksList.length > 0 ? (
        <>
          <MasterTaskTable heading>
            <TableItem>
              <TableText>{t('task_code')}</TableText>
            </TableItem>
            <TableItem>
              <TableText>{t('name')}</TableText>
            </TableItem>
            <TableItem>
              <TableText>{t('public_zone')}</TableText>
            </TableItem>
            <TableItem>
              <TableText>{t('related_offices')}</TableText>
            </TableItem>
            <TableItem>
              <TableText>{t('related_master_tasks')}</TableText>
            </TableItem>
            <TableItem>
              <TableText />
            </TableItem>
          </MasterTaskTable>
          {masterSubTasksList?.map((task, i) => (
            <MasterTaskTable key={task.id}>
              <TableItem>
                <TableText>{task.code}</TableText>
              </TableItem>
              <TableItem>
                <TableText>{task.name}</TableText>
              </TableItem>
              <TableItem>
                <TableText>
                  {
                    publicZoneList.find(zone => zone.id === task.public_zone_id)
                      ?.name
                  }
                </TableText>
              </TableItem>
              <TableItem>
                {task.office && task.office.length > 0 ? (
                  <div style={{ maxWidth: '250px', width: '100%' }}>
                    <TableCustomCheckboxDropdown
                      width="200px"
                      opened={openedOfficeDropdown === task.id}
                      options={task.office.map(office => ({
                        label: office.name,
                        value: office.id,
                      }))}
                      selectedOptions={task.office.map(office => ({
                        label: office.name,
                        value: office.id,
                      }))}
                      onClick={() => handleOfficeDropdownClick(task.id)}
                      onChange={() => {}} // Read-only, no changes needed
                      placeholder="related_offices"
                      countLabel="offices"
                      styles={{
                        button: {
                          cursor: 'default',
                        },
                        menu: {
                          zIndex: 100,
                        },
                      }}
                    />
                  </div>
                ) : (
                  <TableText>-</TableText>
                )}
              </TableItem>
              <TableItem>
                {task.master_tasks && task.master_tasks.length > 0 ? (
                  <div style={{ maxWidth: '250px', width: '100%' }}>
                    <TableCustomCheckboxDropdown
                      width="200px"
                      opened={openedMasterTaskDropdown === task.id}
                      options={task.master_tasks.map(task => ({
                        label: task.name,
                        value: task.id,
                      }))}
                      selectedOptions={task.master_tasks.map(task => ({
                        label: task.name,
                        value: task.id,
                      }))}
                      onClick={() => handleMasterTaskDropdownClick(task.id)}
                      onChange={() => {}} // Read-only, no changes needed
                      placeholder="related_master_tasks"
                      countLabel="master_tasks"
                      styles={{
                        button: {
                          cursor: 'default',
                        },
                        menu: {
                          zIndex: 100,
                        },
                      }}
                    />
                  </div>
                ) : (
                  <TableText>-</TableText>
                )}
              </TableItem>

              <TableItem>
                <RoundIcon
                  height="24px"
                  width="24px"
                  type="edit"
                  onClick={() => handleEdit(task)}
                >
                  <CommonImage src={editIcon} alt="" size="14px" />
                  <TaskActionTooltip toolTipText={t('edit_subtask')} />
                </RoundIcon>
              </TableItem>
            </MasterTaskTable>
          ))}
        </>
      ) : (
        <NoDataComponent
          title={t('no_master_subtasks_found')}
          padding="5vh 0"
          imageHeight="140px"
        />
      )}
    </Container>
  );
};

export default MasterSubTasksList;
